import type { FC } from 'react';
import { HStack } from '@chakra-ui/react';

import { PaymentCardProductType, PaymentCardStatus } from '__generated__/GQL';
import Button from 'components/_core/Button';
import { CardsView } from 'features/PaymentCards/pages/NewPaymentCardList/types';

import { BadgeFilter } from '../BadgeFilter';
import { usePaymentCardsListState } from '../PaymentCardsListFiltersProvider';
import locales from './locales';

export const FiltersList: FC = () => {
  const { dispatch, filters, view } = usePaymentCardsListState();

  const hasAnyFilters = Object.values(filters).some(
    (filter) => filter.length > 0,
  );

  return (
    <HStack>
      <BadgeFilter
        items={[
          {
            label: locales.filters.cardProductType.items.physical,
            value: PaymentCardProductType.Physical,
          },
          {
            label: locales.filters.cardProductType.items.virtual,
            value: PaymentCardProductType.Virtual,
          },
          {
            label: locales.filters.cardProductType.items.temporary,
            value: PaymentCardProductType.VirtualTemporary,
          },
          {
            label: locales.filters.cardProductType.items.budget,
            value: PaymentCardProductType.VirtualBudget,
          },
        ]}
        name="cardProductType"
      >
        {locales.filters.cardProductType.name}
      </BadgeFilter>
      <BadgeFilter
        items={[
          {
            label: locales.filters.status.items[PaymentCardStatus.Created],
            value: PaymentCardStatus.Created,
          },
          {
            label: locales.filters.status.items[PaymentCardStatus.Inactive],
            value: PaymentCardStatus.Inactive,
          },
          {
            label: locales.filters.status.items[PaymentCardStatus.Active],
            value: PaymentCardStatus.Active,
          },
          {
            label: locales.filters.status.items[PaymentCardStatus.Locked],
            value: PaymentCardStatus.Locked,
          },
          {
            label: locales.filters.status.items[PaymentCardStatus.Deactivated],
            value: PaymentCardStatus.Deactivated,
          },
        ]}
        name="status"
      >
        {locales.filters.status.name}
      </BadgeFilter>
      {view === CardsView.COMPANY ? (
        <BadgeFilter items={[]} name="owner">
          {locales.filters.owner.name}
        </BadgeFilter>
      ) : null}
      <Button
        isDisabled={!hasAnyFilters}
        marginLeft="auto"
        onClick={() => {
          dispatch({ type: 'RESET_FILTERS' });
        }}
        variant="inline-primary"
      >
        {locales.clearFilters}
      </Button>
    </HStack>
  );
};
